import { privilagesURLs, userManagementURLs } from "../data/constants";
import { getJson, postJson, putJson } from "../utils/httpService";
import { encrypt } from "../utils/encrypt";

async function getprivileges(token) {
  try {
    return await getJson(privilagesURLs.getprivileges, token);
  } catch (e) {
    throw e;
  }
}

async function getUsersList(token) {
  try {
    return await getJson(userManagementURLs.getUsersList, token);
  } catch (e) {
    throw e;
  }
}

async function createUserService(data, token) {
  try {
    return await postJson(
      userManagementURLs.createUser,
      {
        loginId: data.loginId,
        privilegeCode: data.privilege,
        password: encrypt(data.password),
        pin: encrypt(data.pin),
        msisdn: data.msisdn,
      },
      token
    );
  } catch (e) {
    throw e;
  }
}

async function deleteUserService(loginId, token) {
  try {
    return await putJson(
      userManagementURLs.deleteUser + `/${loginId}`,
      null,
      token
    );
  } catch (e) {
    throw e;
  }
}
async function suspendUserService(loginId, token) {
  try {
    return await putJson(
      userManagementURLs.suspendUser + `/${loginId}`,
      null,
      token
    );
  } catch (e) {
    throw e;
  }
}
async function activateUserService(loginId, token) {
  try {
    return await putJson(
      userManagementURLs.activateUser + `/${loginId}`,
      null,
      token
    );
  } catch (e) {
    throw e;
  }
}

export {
  getprivileges,
  getUsersList,
  createUserService,
  suspendUserService,
  deleteUserService,
  activateUserService,
};
